module.exports = __webpack_public_path__ + "media/video.3f33a416.mp4";